import { useSelector } from 'react-redux';
import { selectOrganizationsList } from '@gandi/redux-organization';
import { selectPersonal, selectPersonalId } from '@gandi/redux-sharing';
import { mapFormDataToTemplate } from './models/mapData';
/**
 * This hook provides initial values and user's personal sharingId & orgname
 */
export const useCreationInitialFormData = () => {
  const personalId = useSelector(selectPersonalId);
  const personalOrga = useSelector(selectPersonal);
  return {
    name: '',
    sharingId: personalId,
    /**
     * DEPRECATED, we should only use sharingId & potentialy sharingName
     * as form values cf. TemplateFormData type
     */
    orgname: personalOrga?.name || '',
    default_registration: false,
    default_transfer: false
  };
};

/**
 * This hook provides mapFormDataToTemplate function
 * taking into account the sharingId & retrieve the orgname from it
 * injecting it into the form for backward compatibility
 */
/**
 * XXX: Temporary solution to populate orgname field
 */
export const useMapFormDataToTemplate = () => {
  const rawOrg = useSelector(state => selectOrganizationsList(state, {
    with_product_count: false
  }));
  return (formData, template) => {
    const orga = rawOrg.find(o => o.id === formData.sharingId);

    // $FlowFixMe[incompatible-type]
    return mapFormDataToTemplate({
      ...formData,
      orgname: orga?.orgname || orga?.name || formData.orgname || ''
    },
    // $FlowFixMe[incompatible-call]: flow doesn't like to go from exact to partial
    template);
  };
};